import { styled } from '@mui/material/styles';
import { Fab, Stack, Paper, Grid } from '@mui/material';
import { Typography } from '../../../components/atoms/Typography';
import { Box } from '../../../components/atoms/Box';

export const LoadingWrapper = styled(Grid)`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;

export const ServiceUpdateHeadingGrid = styled(Grid)<{ isMobileView: boolean; hasTags: boolean }>(
  ({ isMobileView, hasTags }) => `
  align-items: center;
  margin-top: ${!isMobileView && hasTags ? '10px' : '0px'};
  margin-bottom: ${!isMobileView && hasTags ? '12px' : '0px'};
`);

export const ServiceUpdateTypography = styled(Typography)<{ isMobileView: boolean }>(
  ({ isMobileView }) => `
    ${isMobileView 
    ? `
          padding-bottom: 10px;
          margin-top: -10px;
        `
    : `
          margin-top: -15px;
          margin-bottom: -10px;
        `
}`);

export const AddTagFabButton = styled(Fab)`
  transform: scale(0.4);
`;

export const ServiceSummeryBox = styled(Box)`
  width: 100%;
  padding: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  background-color: #ffffff;
  box-sizing: border-box;
  margin-bottom: 10px;
`;

export const SummeryHeaderBox = styled(Box)`
  width: 100%;
  padding: 16px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: #fafafa;
  box-sizing: border-box;
  margin-bottom: 24px;
`;

export const Container = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #000;
  background-color: white;
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 85%;
  max-width: 400px;
`;

export const Footer = styled(Stack)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ContentBox = styled('div')`
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const CarouselWrapper = styled(Paper)`
  padding: 10px;
  border-radius: 7px;
`;

export const StyledCarouselContent = styled(Stack)`
  flex-direction: row;
  margin-left: 20px;
  align-items: center;
`;